import { importImage } from "lib/legacy";
import cx from "classnames";
import "./TokenIcon.scss";

function getIconUrlPath(symbol, size: 24 | 40) {
  if (!symbol || !size) return;
  return `ic_${symbol.toLowerCase()}_${size}.svg`;
}

function tryImportImage(path: string | undefined): string | undefined {
  if (!path) return undefined;
  try {
    return importImage(path);
  } catch {
    return undefined;
  }
}

type Props = {
  symbol: string;
  displaySize: number;
  importSize?: 24 | 40;
  className?: string;
  badge?: string | readonly [topSymbol: string, bottomSymbol: string];
};

function TokenIcon({ className, symbol, displaySize, importSize = 24, badge }: Props) {
  const iconPath = getIconUrlPath(symbol, importSize);
  const classNames = cx("Token-icon inline", className);

  if (!iconPath) return <></>;

  const imgSrc = tryImportImage(iconPath);
  if (!imgSrc) return <></>;

  let sub;
  const img = (
    <img
      data-qa="token-icon"
      className={classNames}
      src={imgSrc}
      alt={symbol}
      width={displaySize}
      height={displaySize}
    />
  );

  if (badge) {
    if (typeof badge === "string") {
      sub = (
        <span className="pointer-events-none absolute -bottom-8 -right-8 z-10 rounded-20 border border-slate-800 bg-slate-500 px-4 py-2 text-12 !text-white">
          {badge}
        </span>
      );
    } else {
      const badgeSrc0 = tryImportImage(getIconUrlPath(badge[0], 24));
      const badgeSrc1 = tryImportImage(getIconUrlPath(badge[1], 24));
      sub = (
        <span className="absolute -bottom-8 -right-8 flex flex-row items-center justify-center !text-white">
          {badgeSrc0 && (
            <img
              className="z-20 -mr-10 rounded-[100%] border border-slate-800"
              src={badgeSrc0}
              alt={badge[0]}
              width={20}
              height={20}
            />
          )}
          {badgeSrc1 && (
            <img
              className="z-10 rounded-[100%] border border-slate-800"
              src={badgeSrc1}
              alt={badge[0]}
              width={20}
              height={20}
            />
          )}
        </span>
      );
    }
  }

  if (!sub) {
    return img;
  }

  return (
    <span className="relative">
      {img}
      {sub}
    </span>
  );
}

export default TokenIcon;
